'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCoffee = function TiCoffee(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 31.7h-20c-0.9 0-1.6-0.8-1.6-1.7s0.7-1.7 1.6-1.7h20c1 0 1.7 0.8 1.7 1.7s-0.7 1.7-1.7 1.7z m0.9-23.4h-20.9v15c0 1.9 1.5 3.4 3.4 3.4h13.3c1.8 0 3.3-1.5 3.3-3.4v-3.3h0.9c3.2 0 5.8-2.6 5.8-5.8s-2.6-5.9-5.8-5.9z m-4.2 15h-13.3v-11.6h13.3v11.6z m4.2-6.6h-2.5v-5h2.5c1.3 0 2.5 1.1 2.5 2.5s-1.2 2.5-2.5 2.5z' })
        )
    );
};

exports.default = TiCoffee;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/coffee.js
// module id = 2020
// module chunks = 0